import { SEO } from "@/components/SEO";
import { Reveal } from "@/components/Section";

const SECTIONS = [
  {
    title: "What We Collect",
    body: "When you contact us or register your interest in WearSpray IQ, we collect the information you choose to provide: your name, email address, and any optional details such as country or age range. For the WearSpray IQ registration, we also collect your questionnaire responses about product preferences, usage habits, and feature interest, along with your communication consent choices. We do not collect medical diagnoses, sensitive health information, or identifiable biometric data through this form.",
  },
  {
    title: "How We Use It",
    body: "We use this information to understand interest in our products and platform, respond to inquiries, and — only if you've given separate, explicit consent — to send WearSpray IQ development updates or invite you to participate in research and product evaluation opportunities. Submitting a registration does not guarantee selection for any future program.",
  },
  {
    title: "Consent & Communication",
    body: "Marketing updates and research invitations are each opt-in via separate checkboxes; leaving a box unchecked means we will not contact you for that purpose. You can withdraw consent at any time by emailing us at the address below.",
  },
  {
    title: "Data Storage & Sharing",
    body: "Submissions are stored securely and are only accessible to the WearSpray team. We do not sell personal information to third parties.",
  },
  {
    title: "Your Rights",
    body: "You may request access to, correction of, or deletion of your information at any time by contacting us.",
  },
];

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="privacy-policy-page">
      <SEO
        title="Privacy Policy | WearSpray"
        description="How WearSpray collects, uses, and protects the information you share with us, including the WearSpray IQ registration form."
        path="/privacy"
      />
      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-36 pb-24">
        <Reveal>
          <span className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-500 block mb-4">Legal</span>
          <h1 className="font-heading text-4xl sm:text-5xl font-light tracking-tight">Privacy Policy</h1>
          <p className="font-body text-zinc-500 text-sm mt-4">Last updated February 2026</p>
        </Reveal>
        <div className="space-y-10 mt-14">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.05}>
              <h2 className="font-heading text-xl font-medium text-white mb-3">{s.title}</h2>
              <p className="font-body text-zinc-400 leading-relaxed">{s.body}</p>
            </Reveal>
          ))}
          <Reveal delay={0.3}>
            <h2 className="font-heading text-xl font-medium text-white mb-3">Contact Us</h2>
            <p className="font-body text-zinc-400 leading-relaxed">
              Questions about this policy or your data? Email us at{" "}
              <a href="mailto:greg@wearspray.com" className="text-accent hover:underline">greg@wearspray.com</a>.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
